var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 13,
    viewBox: "0 0 26 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5C0.5 3.0625 3.27344 0.25 6.75 0.25H10.8125C11.3203 0.25 11.75 0.679688 11.75 1.1875C11.75 1.73438 11.3203 2.125 10.8125 2.125H6.75C4.32812 2.125 2.375 4.11719 2.375 6.5C2.375 8.92188 4.32812 10.875 6.75 10.875H10.8125C11.3203 10.875 11.75 11.3047 11.75 11.8125C11.75 12.3594 11.3203 12.75 10.8125 12.75H6.75C3.27344 12.75 0.5 9.97656 0.5 6.5ZM19.25 12.75H15.1875C14.6406 12.75 14.25 12.3594 14.25 11.8125C14.25 11.3047 14.6406 10.875 15.1875 10.875H19.25C21.6328 10.875 23.625 8.92188 23.625 6.5C23.625 4.11719 21.6328 2.125 19.25 2.125H15.1875C14.6406 2.125 14.25 1.73438 14.25 1.1875C14.25 0.679688 14.6406 0.25 15.1875 0.25H19.25C22.6875 0.25 25.5 3.0625 25.5 6.5C25.5 9.97656 22.6875 12.75 19.25 12.75ZM17.0625 5.5625C17.5703 5.5625 18 5.99219 18 6.5C18 7.04688 17.5703 7.4375 17.0625 7.4375H8.9375C8.39062 7.4375 8 7.04688 8 6.5C8 5.99219 8.39062 5.5625 8.9375 5.5625H17.0625Z",
    fill: "#606B71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSimple);
export default __webpack_public_path__ + "static/media/link-simple.c5460fe6.svg";
export { ForwardRef as ReactComponent };